module.exports = __webpack_public_path__ + "img/product-core-4.bba06a35.png";